import { render, staticRenderFns } from "./EditAmounts.vue?vue&type=template&id=0e3efa0f"
import script from "./EditAmounts.vue?vue&type=script&lang=js"
export * from "./EditAmounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports